export var valuesSortOrder = ["None", "Asc", "Desc"];
//# sourceMappingURL=SortOrder.js.map